<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>系统消息</span></div>
			<div class="center flex-between">
				<centerLeft :menu="2"></centerLeft>
				<div class="center-right">
					<div class="message" v-if="total > 0">
						<div class="message-title">系统消息</div>
						
						<router-link :to="'/usermessageinfo?id='+item.id" class="item" v-for="item in list" :key="item.id">
							<div class="item-title flex-between flex-center" :class="item.readStatus == 1?'active':''">
								<div class="item-title-name one"><span v-if="item.readStatus == 1"></span>{{item.title}}</div>
								<div class="item-title-time">{{item.messageTime}}</div>
							</div>
							<div class="item-info flex-between flex-center">
								<div class="item-info-text one">{{item.info}}</div>
								<div class="item-info-more flex-end flex-center">查看更多<img  src="@/assets/images/right.png"/></div>
							</div>
						</router-link>
					</div>
					<div class="page" v-if="total > 0">
					    <el-pagination @current-change="getPageList" :current-page="page" :page-size="limit" layout="total, prev, pager, next" :total="total"></el-pagination>
					</div>
					
					
					<noData v-if="list.length == 0 && isLoad == true" msg="暂无消息"></noData>
				</div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
import noData from '@/components/noData.vue'
import {sysMessageList} from "@/api/user"
export default {
	name: 'index',
	components:{
		centerLeft,
		noData
	},
	data(){
		return {
			list:[],
			page:1,
			limit:5,
			total:0,
			isLoad:false,
			status:"",
			time:[]
		}
	},
	mounted() {
		this.isLoad = false;
		this.getList();
	},
	methods:{
		getList(){
			sysMessageList({condition:{},page:this.page,size:this.limit}).then(res=>{
				if(res.code == 1000){
					this.list = res.data.list;
					this.total = res.data.total;
					this.isLoad = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		getPageList(e){
			this.isLoad = false;
			this.page = e;
			this.getList();
		},
		toInfo(id){
			this.$router.push("/userrefundinfo?id="+id);
		},
	}
}
</script>

<style lang="scss" scoped>
	.item{
		width: 962px;
		border: 1px solid rgba(7, 11, 19, 0.1);
		margin-top: 20px;
		display: block;
		.item-title{
			width: 100%;
			height: 46px;
			background: rgba(7, 11, 19, 0.04);
			padding: 0px 20px;
			box-sizing: border-box;
			line-height: 46px;
			.item-title-name{
				font-size: 16px;
				font-weight: 500;
				color: #070B13;
				width: 700px;
			}
			.item-title-time{
				font-size: 14px;
				color: rgba(7, 11, 19, 0.6);
	
			}
		}
		.active{
			background: rgba(233, 26, 18, 0.04);
			span{
				width: 10px;
				height: 10px;
				background: #E91A12;
				display: inline-block;
				border-radius: 100%;
				margin-right: 8px;
			}
	
		}
		.item-info{
			padding: 30px 20px;
			.item-info-text{
				font-size: 16px;
				color: #070B13;
				width: 700px;
			}
			.item-info-more{
				font-size: 14px;
				line-height: 24px;
				color: #070B13;
				img{
					width: 20px;
					height: 20px;
				}
			}
		}
	}
	.message{
		padding: 20px 0px;
	}
	.message-title{
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		color: #070B13;
	}
	.center-right{
		min-height: 920px;
		width: 100%;
		padding: 0px 40px;
		box-sizing: border-box;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	@import url("../assets/user.scss");
</style>
